/**
 * Input — dark input with focus glow + optional label / error / prefix / suffix.
 */
import { forwardRef, useId } from "react";

const Input = forwardRef(function Input(
  { label, error, hint, prefix, suffix, className = "", inputClassName = "", id, ...rest },
  ref
) {
  const autoId = useId();
  const _id = id || autoId;
  return (
    <label htmlFor={_id} className={`block ${className}`}>
      {label && (
        <div className="text-[10px] tracking-[0.25em] uppercase text-ink-2 mb-1.5">
          {label}
        </div>
      )}
      <div
        className={
          "flex items-stretch bg-base border rounded-lg transition-all duration-150 " +
          (error
            ? "border-danger"
            : "border-line focus-within:border-pink focus-within:shadow-glow-pink")
        }
      >
        {prefix && <div className="flex items-center pl-3 text-ink-3 text-sm">{prefix}</div>}
        <input
          id={_id}
          ref={ref}
          className={
            "flex-1 bg-transparent px-3 py-2.5 text-sm text-ink placeholder-ink-3 " +
            "focus:outline-none " + inputClassName
          }
          {...rest}
        />
        {suffix && <div className="flex items-center pr-3 text-ink-3 text-sm">{suffix}</div>}
      </div>
      {error && <div className="text-[11px] text-danger mt-1">{error}</div>}
      {hint && !error && <div className="text-[10px] tracking-widest uppercase text-ink-3 mt-1">{hint}</div>}
    </label>
  );
});

export default Input;
